import { render, staticRenderFns } from "./APIUsersDashboard.vue?vue&type=template&id=15e886bc"
import script from "./APIUsersDashboard.vue?vue&type=script&lang=ts"
export * from "./APIUsersDashboard.vue?vue&type=script&lang=ts"
import style0 from "./APIUsersDashboard.vue?vue&type=style&index=0&id=15e886bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports